__turbopack_context__.v({
  "close_menu": "menu-module-scss-module__uQ_9VW__close_menu",
  "login": "menu-module-scss-module__uQ_9VW__login",
  "logo": "menu-module-scss-module__uQ_9VW__logo",
  "menu": "menu-module-scss-module__uQ_9VW__menu",
  "menu__isActive": "menu-module-scss-module__uQ_9VW__menu__isActive",
  "menu_arrowIcon": "menu-module-scss-module__uQ_9VW__menu_arrowIcon",
  "menu_background": "menu-module-scss-module__uQ_9VW__menu_background",
  "menu_background__isActive": "menu-module-scss-module__uQ_9VW__menu_background__isActive",
  "menu_icon": "menu-module-scss-module__uQ_9VW__menu_icon",
  "menu_top": "menu-module-scss-module__uQ_9VW__menu_top",
  "menu_userAvatar": "menu-module-scss-module__uQ_9VW__menu_userAvatar",
  "menu_userButton": "menu-module-scss-module__uQ_9VW__menu_userButton",
  "menu_userInfo": "menu-module-scss-module__uQ_9VW__menu_userInfo",
  "menu_userInfoBlock": "menu-module-scss-module__uQ_9VW__menu_userInfoBlock",
  "menu_userName": "menu-module-scss-module__uQ_9VW__menu_userName",
  "nav": "menu-module-scss-module__uQ_9VW__nav",
  "nav_arrowIcon": "menu-module-scss-module__uQ_9VW__nav_arrowIcon",
  "nav_completeBadge": "menu-module-scss-module__uQ_9VW__nav_completeBadge",
  "nav_divider": "menu-module-scss-module__uQ_9VW__nav_divider",
  "nav_icon": "menu-module-scss-module__uQ_9VW__nav_icon",
  "nav_indicatorsArea": "menu-module-scss-module__uQ_9VW__nav_indicatorsArea",
  "nav_item": "menu-module-scss-module__uQ_9VW__nav_item",
  "nav_link": "menu-module-scss-module__uQ_9VW__nav_link",
  "nav_logout": "menu-module-scss-module__uQ_9VW__nav_logout",
  "nav_messageIndicator": "menu-module-scss-module__uQ_9VW__nav_messageIndicator",
  "nav_messageIndicatorHelpdesk": "menu-module-scss-module__uQ_9VW__nav_messageIndicatorHelpdesk",
  "settingsPickers": "menu-module-scss-module__uQ_9VW__settingsPickers",
  "upgradeAccount": "menu-module-scss-module__uQ_9VW__upgradeAccount",
  "upgradeAccount_avatar": "menu-module-scss-module__uQ_9VW__upgradeAccount_avatar",
  "upgradeAccount_avatarIcon": "menu-module-scss-module__uQ_9VW__upgradeAccount_avatarIcon",
  "upgradeAccount_avatarIconSvg": "menu-module-scss-module__uQ_9VW__upgradeAccount_avatarIconSvg",
  "upgradeAccount_description": "menu-module-scss-module__uQ_9VW__upgradeAccount_description",
  "upgradeAccount_title": "menu-module-scss-module__uQ_9VW__upgradeAccount_title",
  "userVerifications": "menu-module-scss-module__uQ_9VW__userVerifications",
  "userVerifications_icon": "menu-module-scss-module__uQ_9VW__userVerifications_icon",
  "userVerifications_icon__isChecked": "menu-module-scss-module__uQ_9VW__userVerifications_icon__isChecked",
  "userVerifications_icon__isError": "menu-module-scss-module__uQ_9VW__userVerifications_icon__isError",
  "userVerifications_icon__isPending": "menu-module-scss-module__uQ_9VW__userVerifications_icon__isPending",
  "userVerifications_icon__isRejected": "menu-module-scss-module__uQ_9VW__userVerifications_icon__isRejected",
  "userVerifications_item": "menu-module-scss-module__uQ_9VW__userVerifications_item",
  "userVerifications_list": "menu-module-scss-module__uQ_9VW__userVerifications_list",
});
